var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: {
      size: "md",
      withBgClickEvent: true,
      contentClass: "pt-10 sm:pt-10",
    },
    on: { close: _vm.closeModal },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c(
              "span",
              {
                staticClass:
                  "cursor-pointer flex items-center justify-center absolute top-2 right-2",
                on: {
                  click: _vm.closeModal,
                  mouseover: function ($event) {
                    _vm.isHovered = true
                  },
                  mouseout: function ($event) {
                    _vm.isHovered = false
                  },
                },
              },
              [
                !_vm.isHovered
                  ? _c("CrossIcon", { staticClass: "h-4 w-4" })
                  : _vm._e(),
                _vm.isHovered
                  ? _c("CrossIconHover", { staticClass: "h-4 w-4" })
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            !_vm.isStartTimePassed
              ? _c(
                  "div",
                  {
                    staticClass:
                      "flex flex-col font-outfit items-center gap-5 bg-white rounded-lg",
                  },
                  [
                    _vm.shouldShowGeofenceMap
                      ? _c(
                          "div",
                          { staticClass: "h-44 w-full" },
                          [
                            _c(
                              "gmap-map",
                              {
                                staticStyle: {
                                  width: "inherit",
                                  height: "inherit",
                                },
                                attrs: {
                                  center: _vm.currentLocation,
                                  zoom: 16,
                                  "map-type-id": "roadmap",
                                },
                              },
                              [
                                _c("gmap-circle", {
                                  attrs: {
                                    center: _vm.passedLocation,
                                    radius: 70,
                                    options: {
                                      strokeColor: "#3b82f6",
                                      strokeOpacity: 0.5,
                                      strokeWeight: 1,
                                      fillColor: "#3b82f6",
                                      fillOpacity: 0.2,
                                    },
                                  },
                                }),
                                _c("gmap-marker", {
                                  attrs: {
                                    position: _vm.currentLocation,
                                    icon: _vm.customIcons.current,
                                    clickable: true,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleInfo("current")
                                    },
                                  },
                                }),
                                _vm.infoWindow === "current"
                                  ? _c(
                                      "gmap-info-window",
                                      {
                                        attrs: {
                                          options: {
                                            pixelOffset: {
                                              width: 0,
                                              height: -20,
                                            },
                                          },
                                          position: _vm.currentLocation,
                                        },
                                        on: {
                                          closeclick: function ($event) {
                                            _vm.infoWindow = null
                                          },
                                        },
                                      },
                                      [
                                        _c("p", { staticClass: "text-sm" }, [
                                          _vm._v("You are here"),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                                _c("gmap-marker", {
                                  attrs: {
                                    position: _vm.passedLocation,
                                    icon: _vm.customIcons.passed,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.isVirtualVisit
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "w-full flex flex-col items-center gap-3",
                          },
                          [
                            _vm.activity.virtual_meeting_link
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-col items-center gap-1",
                                  },
                                  [
                                    _c(
                                      "p",
                                      { staticClass: "text-xs text-gray-400" },
                                      [_vm._v("Meeting Link:")]
                                    ),
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "text-blue-600 hover:underline text-sm font-medium break-all text-center px-4",
                                        attrs: {
                                          href: _vm.activity
                                            .virtual_meeting_link,
                                          target: "_blank",
                                          rel: "noopener noreferrer",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.activity.virtual_meeting_link
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.activity.fallback_num
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex items-center gap-2 text-gray-600 text-sm",
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          xmlns: "http://www.w3.org/2000/svg",
                                          width: "14",
                                          height: "14",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "2",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
                                          },
                                        }),
                                      ]
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        "Backup Contact: " +
                                          _vm._s(_vm.activity.fallback_num)
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex flex-col items-center gap-5 flex-1 w-full",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex flex-col items-center gap-3 w-full",
                          },
                          [
                            _vm.shouldShowGeofenceMap
                              ? _c(
                                  "p",
                                  { staticClass: "text-xs text-gray-400" },
                                  [
                                    _vm._v(
                                      "Geofence check in radius size is 70 metres."
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex w-full justify-between items-center",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex flex-col items-start" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "text-xs text-gray-400" },
                                      [_vm._v("Shift")]
                                    ),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-sm font-medium text-black",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.formattedTime(
                                                _vm.activity.start_time
                                              )
                                            ) +
                                            " - " +
                                            _vm._s(
                                              _vm.formattedTime(
                                                _vm.activity.end_time
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c("div", {
                                  staticClass:
                                    "border-r h-full border-light-gray",
                                }),
                                _c(
                                  "div",
                                  { staticClass: "flex flex-col items-start" },
                                  [
                                    _vm.isCurrentClockType === "IN"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-xs text-gray-400",
                                          },
                                          [_vm._v(" Clock-in range ")]
                                        )
                                      : _vm._e(),
                                    _vm.isCurrentClockType === "OUT"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-xs text-gray-400",
                                          },
                                          [_vm._v(" Clock-out range ")]
                                        )
                                      : _vm._e(),
                                    _vm.isCurrentClockType === "IN"
                                      ? _c(
                                          "p",
                                          {
                                            staticClass:
                                              "text-sm font-medium text-black",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.clockinStartTime) +
                                                " - " +
                                                _vm._s(_vm.clockinEndTime) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.isCurrentClockType === "OUT"
                                      ? _c(
                                          "p",
                                          {
                                            staticClass:
                                              "text-sm font-medium text-black",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.formattedTime(
                                                    _vm.activity.end_time
                                                  )
                                                ) +
                                                " - " +
                                                _vm._s(_vm.clockoutEndTime) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            ),
                            _vm.currentClockInOutStatus === "ON_TIME"
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-col items-center p-1 justify-center gap-2 w-full bg-primary-green rounded",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "inline-flex flex-col items-center justify-center gap-px",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-sm text-gray-400",
                                          },
                                          [_vm._v("Time")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-xl font-medium text-badge",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.currentClockinTime) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "text-sm text-black" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.currentClockinDate)
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "flex items-center gap-2",
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "rounded h-1.5 w-1.5 border bg-skill-green",
                                        }),
                                        _c("div", [_vm._v("On Time")]),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.currentClockInOutStatus === "EARLY" &&
                            _vm.isCurrentClockType === "IN" &&
                            !_vm.activity.disable_time_alerts
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-col items-center p-3 justify-center gap-3 w-full bg-yellow-50 border border-yellow-200 rounded",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex items-center gap-2 text-yellow-800",
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            staticClass: "w-5 h-5",
                                            attrs: {
                                              fill: "currentColor",
                                              viewBox: "0 0 20 20",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                "fill-rule": "evenodd",
                                                d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
                                                "clip-rule": "evenodd",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "font-medium" },
                                          [_vm._v("Early Clock-in Notice")]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "text-sm text-yellow-800 text-center",
                                      },
                                      [
                                        _vm._v(
                                          " You are clocking in outside the recommended window (5 minutes before start time). This will send an automatic notification email to your manager. "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.currentClockInOutStatus === "OUTSIDE" &&
                            _vm.shouldShowGeofenceMap
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-col items-center p-3 justify-center gap-3 w-full bg-red-50 border border-red-200 rounded",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex items-center gap-2 text-red-800",
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            staticClass: "w-5 h-5",
                                            attrs: {
                                              fill: "currentColor",
                                              viewBox: "0 0 20 20",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                "fill-rule": "evenodd",
                                                d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
                                                "clip-rule": "evenodd",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "font-medium" },
                                          [_vm._v("Outside Geofence Notice")]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "text-sm text-red-800 text-center",
                                      },
                                      [
                                        _vm._v(
                                          " You are outside the required location for this visit. This will send an automatic notification email to your manager. "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.currentClockInOutStatus === "EARLY" &&
                            !_vm.activity.disable_time_alerts
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-col items-center p-1 justify-center gap-2 w-full bg-danger-red rounded",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "inline-flex flex-col items-center justify-center gap-px",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-sm text-gray-400",
                                          },
                                          [_vm._v("Time")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-xl font-medium text-alert-red",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.currentClockinTime) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "text-sm text-black" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.currentClockinDate)
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "flex items-center gap-2",
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "rounded h-1.5 w-1.5 border bg-alert-red",
                                        }),
                                        _vm.isCurrentClockType === "IN"
                                          ? _c("div", [
                                              _vm._v("Early Clock-in"),
                                            ])
                                          : _vm._e(),
                                        _vm.isCurrentClockType === "OUT"
                                          ? _c("div", [
                                              _vm._v("Early Clock-out"),
                                            ])
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.currentClockInOutStatus === "LATE" &&
                            !_vm.activity.disable_time_alerts
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-col items-center p-1 justify-center gap-2 w-full bg-danger-red rounded",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "inline-flex flex-col items-center justify-center gap-px",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-sm text-gray-400",
                                          },
                                          [_vm._v("Time")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-xl font-medium text-alert-red",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.currentClockinTime) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "text-sm text-black" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.currentClockinDate)
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "flex items-center gap-2",
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "rounded h-1.5 w-1.5 border bg-alert-red",
                                        }),
                                        _vm.isCurrentClockType === "IN"
                                          ? _c("div", [
                                              _vm._v("Clocked-in late"),
                                            ])
                                          : _vm._e(),
                                        _vm.isCurrentClockType === "OUT"
                                          ? _c("div", [
                                              _vm._v("Clocked-out late"),
                                            ])
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.currentClockInOutStatus === "OUTSIDE" &&
                            _vm.shouldShowGeofenceMap
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-col items-center p-1 justify-center gap-2 w-full bg-warning-orange rounded",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "inline-flex flex-col items-center justify-center gap-px",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-sm text-gray-400",
                                          },
                                          [_vm._v("Time")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-xl font-medium text-alert-red",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.currentClockinTime) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "text-sm text-black" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.currentClockinDate)
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "flex items-center gap-2",
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "rounded h-1.5 w-1.5 border bg-warning-dark-orange",
                                        }),
                                        _vm.isCurrentClockType === "IN"
                                          ? _c("div", [
                                              _vm._v(
                                                " Clocked-in outside of shift location "
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm.isCurrentClockType === "OUT"
                                          ? _c("div", [
                                              _vm._v(
                                                " Clocked-out outside of shift location "
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "flex w-full flex-col gap-2" },
                          [
                            _vm.clockInDisabledMessage
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-sm text-gray-500 text-center p-2 bg-gray-100 rounded",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.clockInDisabledMessage) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.isCurrentClockType === "IN"
                              ? _c("UiButton", {
                                  staticClass: "text-sm font-normal",
                                  attrs: {
                                    size: "sm",
                                    fullWidth: true,
                                    processing: _vm.processing,
                                    disabled: !_vm.isWithinClockInWindow,
                                    variant: "black",
                                    buttonText: "Clock-in",
                                  },
                                  on: {
                                    click: _vm.onClockIn,
                                    mouseover: function ($event) {
                                      _vm.clockInHovering = true
                                    },
                                    mouseleave: function ($event) {
                                      _vm.clockInHovering = false
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "icon",
                                        fn: function () {
                                          return [
                                            _c("ClockIcon", {
                                              staticClass: "w-4 h-4",
                                            }),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                      {
                                        key: "hover-icon",
                                        fn: function () {
                                          return [
                                            _c("ClockIconBlack", {
                                              staticClass: "w-4 h-4",
                                            }),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    665851973
                                  ),
                                })
                              : _vm._e(),
                            _vm.isCurrentClockType === "OUT"
                              ? _c("UiButton", {
                                  staticClass: "text-sm font-normal",
                                  attrs: {
                                    buttonText: "Clock-out",
                                    processing: _vm.processing,
                                    size: "sm",
                                    fullWidth: true,
                                    variant: "black",
                                  },
                                  on: {
                                    click: _vm.onClockOut,
                                    mouseover: function ($event) {
                                      _vm.clockInHovering = true
                                    },
                                    mouseleave: function ($event) {
                                      _vm.clockInHovering = false
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "icon",
                                        fn: function () {
                                          return [
                                            _c("ClockIcon", {
                                              staticClass: "w-4 h-4",
                                            }),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                      {
                                        key: "hover-icon",
                                        fn: function () {
                                          return [
                                            _c("ClockIconBlack", {
                                              staticClass: "w-4 h-4",
                                            }),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    665851973
                                  ),
                                })
                              : _vm._e(),
                            _c(
                              "UiButton",
                              {
                                staticClass: "text-sm font-normal",
                                attrs: {
                                  size: "sm",
                                  fullWidth: true,
                                  variant: "outline",
                                },
                                on: { click: _vm.closeModal },
                              },
                              [_vm._v(" Cancel ")]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                )
              : _c("div", [
                  _c("p", { staticClass: "p-4" }, [
                    _vm._v(
                      " This visit is in the past. To edit this visit time, please contact your Manager or Admin. "
                    ),
                  ]),
                ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }